import { Nullable } from 'types'

import { cellMinHeight } from './constants'

export const checkScrollPosition = (element: Nullable<HTMLElement>) => {
  if (!element) return false

  const { scrollWidth, clientWidth, scrollLeft } = element
  const isAtEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) < 1
  const hasScroll = scrollWidth > clientWidth

  return hasScroll && !isAtEnd
}

export const calculateCellHeight = (parentHeight: number, intervals: number) => {
  const daysHeight = 60 + 24 // Высота + отступ снизу
  const availableHeight = parentHeight - daysHeight

  const calculatedCellHeight = availableHeight / (intervals + 1)
  return Math.max(calculatedCellHeight, cellMinHeight)
}
